<!-- ============================================================
     USER ACTIVITY LOG
     ============================================================ -->
<div class="al-page">

  @if (toast_msg()) {
    <div class="al-toast alert alert-success d-flex align-items-center gap-2 shadow">
      <i class="bi bi-check-circle-fill fs-5"></i>
      <strong>{{ toast_msg() }}</strong>
    </div>
  }

  @if (show_form()) {
    <div class="al-overlay center" (click)="close_form()">
      <div class="al-form-modal" (click)="$event.stopPropagation()">
        <div class="alh form-header">
          <div class="alh-icon"><i class="bi {{ is_edit() ? 'bi-pencil-square' : 'bi-plus-circle' }}"></i></div>
          <div>
            <h5 class="alh-title">{{ is_edit() ? 'Edit activity' : 'Add activity' }}</h5>
            <p class="alh-sub">{{ is_edit() ? 'Update this log entry' : 'Record a new user activity' }}</p>
          </div>
          <button class="alh-close" (click)="close_form()"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="alb p-4">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label fw-semibold">Existing user</label>
              <select class="form-select" [ngModel]="entry_form.user_id" (ngModelChange)="apply_user($event)">
                <option value="">Select to fill details…</option>
                @for (u of unique_users; track u.user_id) {
                  <option [value]="u.user_id">{{ u.user_name }}</option>
                }
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Date &amp; time <span class="req">*</span></label>
              <input type="datetime-local" class="form-control" [(ngModel)]="form_timestamp"
                     [class.is-invalid]="form_submitted && form_errors['timestamp']">
              @if (form_errors['timestamp']) { <div class="invalid-feedback d-block">{{ form_errors['timestamp'] }}</div> }
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">User name <span class="req">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="entry_form.user_name" maxlength="80"
                     [class.is-invalid]="form_submitted && form_errors['user_name']" placeholder="e.g. Admin User">
              @if (form_errors['user_name']) { <div class="invalid-feedback d-block">{{ form_errors['user_name'] }}</div> }
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Role</label>
              <input type="text" class="form-control" [(ngModel)]="entry_form.user_role" maxlength="60" list="role-list">
              <datalist id="role-list">
                @for (r of role_opts; track r) { <option [value]="r"> }
              </datalist>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Email</label>
              <input type="email" class="form-control" [(ngModel)]="entry_form.user_email" maxlength="100">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Action <span class="req">*</span></label>
              <select class="form-select" [(ngModel)]="entry_form.act_action" (ngModelChange)="on_action_change()"
                      [class.is-invalid]="form_submitted && form_errors['action']">
                @for (a of action_opts; track a.value) {
                  <option [value]="a.value">{{ a.label }}</option>
                }
              </select>
              @if (form_errors['action']) { <div class="invalid-feedback d-block">{{ form_errors['action'] }}</div> }
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Module <span class="req">*</span></label>
              <select class="form-select" [(ngModel)]="entry_form.act_module"
                      [class.is-invalid]="form_submitted && form_errors['module']">
                @for (m of module_opts; track m.value) {
                  <option [value]="m.value">{{ m.label }}</option>
                }
              </select>
              @if (form_errors['module']) { <div class="invalid-feedback d-block">{{ form_errors['module'] }}</div> }
            </div>
            <div class="col-md-2">
              <label class="form-label fw-semibold">Severity</label>
              <select class="form-select" [(ngModel)]="entry_form.severity">
                <option value="info">Info</option>
                <option value="success">Success</option>
                <option value="warning">Warning</option>
                <option value="danger">Danger</option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label fw-semibold">Status</label>
              <select class="form-select" [(ngModel)]="entry_form.status">
                <option value="success">Success</option>
                <option value="failed">Failed</option>
              </select>
            </div>
            <div class="col-12">
              <label class="form-label fw-semibold">Description <span class="req">*</span></label>
              <textarea class="form-control" rows="2" maxlength="250" [(ngModel)]="entry_form.description"
                        placeholder="What happened?"
                        [class.is-invalid]="form_submitted && form_errors['description']"></textarea>
              @if (form_errors['description']) { <div class="invalid-feedback d-block">{{ form_errors['description'] }}</div> }
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Record label</label>
              <input type="text" class="form-control" [(ngModel)]="entry_form.entity_label" maxlength="120" placeholder="e.g. Arjun Sharma · XI-A">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Record ID</label>
              <input type="text" class="form-control" [(ngModel)]="entry_form.entity_id" maxlength="60" placeholder="e.g. gp_2026_118">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Record type</label>
              <input type="text" class="form-control" [(ngModel)]="entry_form.entity_type" maxlength="40" placeholder="e.g. gate_pass">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">IP address</label>
              <input type="text" class="form-control" [(ngModel)]="entry_form.ip_address" maxlength="40">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Device</label>
              <select class="form-select" [(ngModel)]="entry_form.device">
                @for (d of device_opts; track d) { <option [value]="d">{{ d }}</option> }
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Browser</label>
              <select class="form-select" [(ngModel)]="entry_form.browser">
                @for (b of browser_opts; track b) { <option [value]="b">{{ b }}</option> }
              </select>
            </div>
            <div class="col-12">
              <label class="form-label fw-semibold">Notes</label>
              <input type="text" class="form-control" [(ngModel)]="entry_form.notes" maxlength="200" placeholder="Optional extra context">
            </div>
          </div>
        </div>
        <div class="alf">
          <button class="btn btn-outline-secondary px-4" (click)="close_form()">Cancel</button>
          <button class="btn al-btn-primary px-4" (click)="save_entry()">
            <i class="bi bi-check-circle-fill me-1"></i>{{ is_edit() ? 'Update' : 'Add' }}
          </button>
        </div>
      </div>
    </div>
  }

  @if (delete_target(); as row) {
    <div class="al-overlay center" (click)="cancel_delete()">
      <div class="al-modal" (click)="$event.stopPropagation()">
        <div class="alh del-header">
          <div class="alh-icon"><i class="bi bi-trash3-fill"></i></div>
          <div>
            <h5 class="alh-title">Delete this activity?</h5>
            <p class="alh-sub">{{ row.id }}</p>
          </div>
          <button class="alh-close" (click)="cancel_delete()"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="alb p-4">
          <p class="mb-1 fw-semibold">{{ row.description }}</p>
          <p class="text-muted small mb-0">{{ row.user_name }} · {{ action_label(row.act_action) }} · {{ module_label(row.act_module) }}</p>
        </div>
        <div class="alf">
          <button class="btn btn-outline-secondary px-4" (click)="cancel_delete()">Cancel</button>
          <button class="btn btn-danger px-4" (click)="confirm_delete()">
            <i class="bi bi-trash3 me-1"></i>Delete
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Header -->
  <div class="al-ph mb-4">
    <div class="dph-left">
      <div class="al-logo"><i class="bi bi-clock-history"></i></div>
      <div>
        <h1 class="al-title">User Activity Log</h1>
        <p class="al-subtitle">
          Audit trail of sign-ins, record changes, and security events across EduSmart ERP
        </p>
      </div>
    </div>
    <div class="d-flex gap-2 flex-wrap">
      <button class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2" (click)="export_csv()">
        <i class="bi bi-download"></i>
        <span class="d-none d-sm-inline">Export CSV</span>
      </button>
      <button class="btn al-btn-primary btn-sm" (click)="open_add()">
        <i class="bi bi-plus-circle-fill me-1"></i>Add Activity
      </button>
    </div>
  </div>

  <!-- Stats -->
  <div class="al-stats mb-4">
    <button class="alst" (click)="apply_quick('all')" [class.active]="!has_active_filters()">
      <div class="alst-icon bg-total"><i class="bi bi-collection"></i></div>
      <div>
        <div class="alst-val">{{ stats().total }}</div>
        <div class="alst-lbl">Events</div>
      </div>
    </button>
    <button class="alst" (click)="apply_quick('today')">
      <div class="alst-icon bg-today"><i class="bi bi-calendar-event"></i></div>
      <div>
        <div class="alst-val">{{ stats().today }}</div>
        <div class="alst-lbl">Today</div>
      </div>
    </button>
    <button class="alst" (click)="apply_quick('all')">
      <div class="alst-icon bg-users"><i class="bi bi-people"></i></div>
      <div>
        <div class="alst-val">{{ stats().unique_users }}</div>
        <div class="alst-lbl">Users</div>
      </div>
    </button>
    <button class="alst" (click)="apply_quick('mutations')">
      <div class="alst-icon bg-mut"><i class="bi bi-pencil-square"></i></div>
      <div>
        <div class="alst-val">{{ stats().mutations }}</div>
        <div class="alst-lbl">Changes</div>
      </div>
    </button>
    <button class="alst alst-alert" (click)="apply_quick('security')">
      <div class="alst-icon bg-sec"><i class="bi bi-shield-exclamation"></i></div>
      <div>
        <div class="alst-val">{{ stats().security }}</div>
        <div class="alst-lbl">Security</div>
      </div>
    </button>
    <button class="alst alst-alert" (click)="apply_quick('failed')">
      <div class="alst-icon bg-fail"><i class="bi bi-x-octagon"></i></div>
      <div>
        <div class="alst-val">{{ stats().failed }}</div>
        <div class="alst-lbl">Failed</div>
      </div>
    </button>
  </div>

  <!-- Filters -->
  <div class="al-filters mb-3">
    <div class="al-search">
      <i class="bi bi-search"></i>
      <input
        type="text"
        placeholder="Search user, action, entity, IP…"
        [ngModel]="search_query()"
        (ngModelChange)="search_query.set($event); on_filter_change()"
      />
      @if (search_query()) {
        <button class="al-clear" (click)="search_query.set(''); on_filter_change()"><i class="bi bi-x"></i></button>
      }
    </div>

    <!-- <select class="form-select al-select" [ngModel]="user_id()" (ngModelChange)="user_id.set($event); on_filter_change()">
      <option value="">All users</option>
      @for (u of unique_users(); track u.user_id) {
        <option [value]="u.user_id">{{ u.user_name }}</option>
      }
    </select> -->

    <select class="form-select al-select" [ngModel]="module_f()" (ngModelChange)="module_f.set($event); on_filter_change()">
      <option value="">All modules</option>
      @for (m of module_opts; track m.value) {
        <option [value]="m.value">{{ m.label }}</option>
      }
    </select>

    <select class="form-select al-select" [ngModel]="action_f()" (ngModelChange)="action_f.set($event); on_filter_change()">
      <option value="">All actions</option>
      @for (a of action_opts; track a.value) {
        <option [value]="a.value">{{ a.label }}</option>
      }
    </select>

    <select class="form-select al-select" [ngModel]="severity_f()" (ngModelChange)="severity_f.set($event); on_filter_change()">
      <option value="">All severities</option>
      <option value="info">Info</option>
      <option value="success">Success</option>
      <option value="warning">Warning</option>
      <option value="danger">Danger</option>
    </select>

    <input class="form-control al-date" type="date" [ngModel]="date_from()" (ngModelChange)="date_from.set($event); on_filter_change()" title="From" />
    <input class="form-control al-date" type="date" [ngModel]="date_to()" (ngModelChange)="date_to.set($event); on_filter_change()" title="To" />

    @if (has_active_filters()) {
      <button class="btn btn-link btn-sm text-decoration-none" (click)="clear_filters()">Clear</button>
    }

    <!-- <div class="view-toggle ms-auto">
      <button class="vt-btn" [class.active]="view_mode() === 'timeline'" (click)="set_view('timeline')" title="Timeline">
        <i class="bi bi-list-ul"></i>
      </button>
      <button class="vt-btn" [class.active]="view_mode() === 'table'" (click)="set_view('table')" title="Table">
        <i class="bi bi-table"></i>
      </button>
    </div> -->
  </div>

  <div class="al-meta mb-1 d-flex justify-content-between">
    <span>
      Listing <strong>{{ page_data().from }}-{{ page_data().to }}</strong> of <strong>{{ page_data().total }}</strong> records
    </span>
    <div class="view-toggle ms-auto">
      <button class="vt-btn" [class.active]="view_mode() === 'timeline'" (click)="set_view('timeline')" title="Timeline">
        <i class="bi bi-list-ul"></i>
      </button>
      <span>&nbsp;&nbsp;</span>
      <button class="vt-btn" [class.active]="view_mode() === 'table'" (click)="set_view('table')" title="Table">
        <i class="bi bi-table"></i>
      </button>
      <span>&nbsp;&nbsp;</span>
    </div>
  </div>

  <!-- Timeline -->
  @if (view_mode() === 'timeline') {
    <div class="al-card">
      @if (page_data().items.length === 0) {
        <div class="empty-state">
          <i class="bi bi-journal-x"></i>
          <p>No activity matches the current filters.</p>
          @if (has_active_filters()) {
            <button class="btn btn-outline-primary btn-sm" (click)="clear_filters()">Clear filters</button>
          }
        </div>
      } @else {
        @for (group of grouped_by_day(); track group.date) {
          <div class="day-group">
            <div class="day-label">{{ group.label }}</div>
            @for (row of group.items; track row.id) {
              <div class="tl-row" (click)="open_detail(row)">
                <div class="tl-rail">
                  <span class="tl-dot sev-{{ row.severity }}"><i class="bi {{ action_icon(row.act_action) }}"></i></span>
                </div>
                <div class="tl-avatar" [style.background]="initials_color(row.user_avatar)">{{ row.user_avatar }}</div>
                <div class="tl-body">
                  <div class="tl-top">
                    <span class="tl-user">{{ row.user_name }}</span>
                    <span class="tl-role">{{ row.user_role }}</span>
                    <span class="chip chip-{{ row.act_action }}">{{ action_label(row.act_action) }}</span>
                    <span class="chip chip-mod"><i class="bi {{ module_icon(row.act_module) }} me-1"></i>{{ module_label(row.act_module) }}</span>
                  </div>
                  <p class="tl-desc">{{ row.description }}</p>
                  <div class="tl-foot">
                    @if (row.entity_label) {
                      <span><i class="bi bi-link-45deg me-1"></i>{{ row.entity_label }}</span>
                    }
                    <span><i class="bi bi-geo-alt me-1"></i>{{ row.ip_address }}</span>
                    <span><i class="bi bi-laptop me-1"></i>{{ row.device }} · {{ row.browser }}</span>
                  </div>
                </div>
                <div class="tl-time">
                  <span class="t-clock">{{ clock(row.cur_date) }}</span>
                  <span class="t-rel">{{ relative_time(row.cur_date) }}</span>
                  @if (row.status === 'failed') {
                    <span class="status-fail">Failed</span>
                  }
                </div>
                <div class="row-actions" (click)="$event.stopPropagation()">
                  <button class="act-btn" title="View" (click)="open_detail(row)"><i class="bi bi-eye"></i></button>
                  <button class="act-btn" title="Edit" (click)="open_edit(row, $event)"><i class="bi bi-pencil"></i></button>
                  <button class="act-btn danger" title="Delete" (click)="ask_delete(row, $event)"><i class="bi bi-trash3"></i></button>
                </div>
              </div>
            }
          </div>
        }
      }
    </div>
  }

  <!-- Table -->
  @if (view_mode() === 'table') {
    <div class="al-card table-wrap">
      @if (page_data().items.length === 0) {
        <div class="empty-state">
          <i class="bi bi-journal-x"></i>
          <p>No activity matches the current filters.</p>
        </div>
      } @else {
        <div class="table-responsive">
          <table class="table al-table mb-0">
            <thead>
              <tr>
                <th>Time</th>
                <th>User</th>
                <th>Action</th>
                <th>Module</th>
                <th>Description</th>
                <th class="d-none d-xl-table-cell">IP</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (row of page_data().items; track row.id) {
                <tr (click)="open_detail(row)">
                  <td class="nowrap">
                    <div class="fw-semibold">{{ clock(row.cur_date) }}</div>
                    <div class="text-muted small">{{ relative_time(row.cur_date) }}</div>
                  </td>
                  <td>
                    <div class="user-cell">
                      <span class="tl-avatar sm" [style.background]="initials_color(row.user_avatar)">{{ row.user_avatar }}</span>
                      <div>
                        <div class="fw-semibold">{{ row.user_name }}</div>
                        <div class="text-muted small">{{ row.user_role }}</div>
                      </div>
                    </div>
                  </td>
                  <td><span class="chip chip-{{ row.act_action }}">{{ action_label(row.act_action) }}</span></td>
                  <td><span class="chip chip-mod">{{ module_label(row.act_module) }}</span></td>
                  <td>
                    <div>{{ row.description }}</div>
                    @if (row.entity_label) {
                      <div class="text-muted small">{{ row.entity_label }}</div>
                    }
                  </td>
                  <td class="d-none d-xl-table-cell font-mono small text-muted">{{ row.ip_address }}</td>
                  <td (click)="$event.stopPropagation()">
                    <div class="row-actions">
                      <button class="act-btn" title="View" (click)="open_detail(row)"><i class="bi bi-eye"></i></button>
                      <button class="act-btn" title="Edit" (click)="open_edit(row, $event)"><i class="bi bi-pencil"></i></button>
                      <button class="act-btn danger" title="Delete" (click)="ask_delete(row, $event)"><i class="bi bi-trash3"></i></button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }

  <!-- Pagination -->
  <div class="al-pager-bar">
    <div class="pager-info">
      Showing <strong>{{ page_data().from }}–{{ page_data().to }}</strong>
      of <strong>{{ page_data().total }}</strong> records
    </div>
    <label class="pager-size">
      <span>Records</span>
      <select class="form-select form-select-sm"
              [ngModel]="page_size()"
              (ngModelChange)="set_page_size(+$event)">
        @for (n of page_size_opts; track n) {
          <option [ngValue]="n">{{ page_size_label(n) }}</option>
        }
      </select>
    </label>
    <div class="al-pager">
      <button class="pg-btn" title="First page" [disabled]="page_data().page === 1" (click)="go_first()">
        <i class="bi bi-chevron-double-left"></i>
      </button>
      <button class="pg-btn" title="Previous" [disabled]="page_data().page === 1" (click)="go_prev()">
        <i class="bi bi-chevron-left"></i>
      </button>
      @for (p of pages(); track p) {
        <button class="pg-btn" [class.active]="p === page_data().page" (click)="go_to(p)">{{ p }}</button>
      }
      <button class="pg-btn" title="Next" [disabled]="page_data().page === page_data().total_pages" (click)="go_next()">
        <i class="bi bi-chevron-right"></i>
      </button>
      <button class="pg-btn" title="Last page" [disabled]="page_data().page === page_data().total_pages" (click)="go_last()">
        <i class="bi bi-chevron-double-right"></i>
      </button>
    </div>
  </div>

  <!-- Detail drawer -->
  @if (selected_entry(); as row) {
    <div class="al-overlay" (click)="close_detail()">
      <aside class="al-drawer" (click)="$event.stopPropagation()">
        <div class="dr-head">
          <div class="tl-dot sev-{{ row.severity }}"><i class="bi {{ action_icon(row.act_action) }}"></i></div>
          <div>
            <h5 class="dr-title">{{ action_label(row.act_action) }} · {{ module_label(row.act_module) }}</h5>
            <p class="dr-sub">{{ row.id }}</p>
          </div>
          <button class="alh-close" (click)="close_detail()"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="dr-body">
          <p class="dr-desc">{{ row.description }}</p>

          <div class="dr-user">
            <span class="tl-avatar" [style.background]="initials_color(row.user_avatar)">{{ row.user_avatar }}</span>
            <div>
              <div class="fw-semibold">{{ row.user_name }}</div>
              <div class="text-muted small">{{ row.user_role }} · {{ row.user_email }}</div>
            </div>
          </div>

          <dl class="dr-dl">
            <div><dt>When</dt><dd>{{ row.cur_date | date:'EEE, d MMM y, HH:mm:ss' }}</dd></div>
            <div><dt>Status</dt>
              <dd>
                <span class="chip" [class.chip-approve]="row.status === 'success'" [class.chip-login_failed]="row.status === 'failed'">
                  {{ row.status }}
                </span>
              </dd>
            </div>
            <div><dt>Severity</dt><dd class="text-capitalize">{{ row.severity }}</dd></div>
            @if (row.entity_label) {
              <div><dt>Record</dt><dd>{{ row.entity_label }}</dd></div>
            }
            @if (row.entity_id) {
              <div><dt>Record ID</dt><dd class="font-mono">{{ row.entity_id }}</dd></div>
            }
            @if (row.entity_type) {
              <div><dt>Record type</dt><dd>{{ row.entity_type }}</dd></div>
            }
            <div><dt>IP address</dt><dd class="font-mono">{{ row.ip_address }}</dd></div>
            <div><dt>Device</dt><dd>{{ row.device }}</dd></div>
            <div><dt>Browser</dt><dd>{{ row.browser }}</dd></div>
            @if (row.notes) {
              <div><dt>Notes</dt><dd>{{ row.notes }}</dd></div>
            }
          </dl>
          <div class="dr-actions">
            <button class="btn btn-outline-primary btn-sm" (click)="open_edit(row)">
              <i class="bi bi-pencil me-1"></i>Edit
            </button>
            <button class="btn btn-outline-danger btn-sm" (click)="ask_delete(row)">
              <i class="bi bi-trash3 me-1"></i>Delete
            </button>
          </div>
        </div>
      </aside>
    </div>
  }
</div>
